module.exports = __webpack_public_path__ + "static/media/selected-marker-icon.6626775c.png";